import { render, staticRenderFns } from "./FlexLayout.vue?vue&type=template&id=2566631a&scoped=true&"
import script from "./FlexLayout.vue?vue&type=script&lang=js&"
export * from "./FlexLayout.vue?vue&type=script&lang=js&"
import style0 from "./FlexLayout.vue?vue&type=style&index=0&id=2566631a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2566631a",
  null
  
)

export default component.exports